import React, { Fragment, useState, useEffect, useRef } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import EmployerChatMessageItem from "./EmployerChatMessageItem";

const StreamChatBlue = ({
  auth: { user },
  messages,
  message,
  setMessage,
  sendMessage,
  deleteMessage,
  setShowChat,
  isAuthenticated,
  maxLength,
}) => {
  const inputRef = useRef(null);

  const [mention, setMention] = useState(false);

  const [str, setStr] = useState(" ");

  function checkWord(word) {
    word.split(" ").map((x) => {
      if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
        setMention(true);
      } else {
        setMention(false);
      }
    });
  }

  function addMention(e, message) {
    let messageArray = message.split(" ");
    messageArray.pop();
    messageArray.push(e.currentTarget.attributes.value.value);
    setMessage(messageArray.join(" ").toString());
    setMention(false);
  }

  useEffect(() => {
    checkWord(message);
  }, [message]);

  useEffect(() => {
    message.split(" ").map((x) => {
      if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
        setStr(x);
      }
    });
  }, [message]);

  return (
    <Fragment>
      <div className="live-stream-side-container border-left grey">
        <div className="container-name">
          <i
            className="far fa-window-close fa-2x blue close-window"
            onClick={() => setShowChat(false)}
          ></i>
          <p className="container-title blue bold">
            <i className="far fa-comments blue mr-5"></i>Chat
          </p>
          <i className="fas fa-external-link-alt fa-lg blue pop-out"></i>
        </div>
        <ScrollToBottom className="all-content">
          {messages.map((message, index) => (
            <EmployerChatMessageItem
              key={index}
              user={user}
              message={message}
              deleteMessage={deleteMessage}
            />
          ))}
        </ScrollToBottom>
        {isAuthenticated && (
          <div>
            {isAuthenticated && !user.banned && !user.timed_out && (
              <div className="chat-message-container">
                {/* {mention && (
                  <div className="room-users-container">
                    <div className="room-users">
                      <ul>
                        {viewerCount &&
                          viewerCount
                            .filter((y) => {
                              return y.channelid.match(str.substring(1));
                            })
                            .map((c) => {
                              if (c.channelid !== "") {
                                return (
                                  <li
                                    onClick={(e) => {
                                      addMention(e, message);
                                      inputRef.current.focus();
                                    }}
                                    className={`room-user-item ${
                                      c.role === "innovator"
                                        ? "green"
                                        : c && c.role === "mentor"
                                        ? "red"
                                        : c && c.role === "employer"
                                        ? "blue"
                                        : ""
                                    } bold`}
                                    value={`@${c.channelid}`}
                                  >
                                    @{c.channelid}
                                  </li>
                                );
                              }
                            })}
                      </ul>
                    </div>
                  </div>
                )} */}
                <div className="chat-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <input
                    className="chat-input"
                    type="text"
                    value={message}
                    ref={inputRef}
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={100}
                    onKeyPress={(e) => {
                      if (message.length <= maxLength && e.key === "Enter") {
                        sendMessage(e);
                      }
                    }}
                    placeholder="Type message here..."
                  />
                  <p className="white character-counter-comment">
                    {message.length}/{maxLength} characters
                  </p>
                </div>
              </div>
            )}
            {isAuthenticated && user.banned && (
              <div className="chat-message-container grey">
                <div className="user-banned red">
                  <i className="fa-solid fa-ban mr-5 fa-lg red"></i>Banned
                </div>
              </div>
            )}
            {isAuthenticated && user.timed_out && (
              <div className="chat-message-container grey">
                <div className="user-banned red">
                  <i className="fa-solid fa-clock mr-5 fa-lg red"></i>
                  Timed Out
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(StreamChatBlue);
